export const NavItems = [
  {
    text: "Fee Types",
    route: "/back-office/fee-types",
    icon: "charge-type",
    authority: "bo_dd_get_charge_types",
    roles: ["DD_BANK_ADMIN"],
    type: "bo",
    id: "charge-types",
    children: [],
  },
  {
    text: "Participants",
    route: "/back-office/settlement-participants",
    icon: "settlement",
    authority: "bo_dd_view_participant",
    roles: ["DD_BANK_ADMIN"],
    type: "bo",
    id: "participants",
    children: [],
  },
  {
    text: "Payment Facilitators",
    route: "/back-office/payment-facilitators",
    icon: "merchant",
    authority: "bo_dd_get_facilitators",
    roles: ["DD_BANK_ADMIN"],
    type: "bo",
    id: "super-agents",
    children: [],
  },
  {
    text: "Payment Facilitator Users",
    route: "/front-office/payment-facilitator-users",
    icon: "merchant-user",
    authority: "fo_dd_get_all_facilitator_users",
    roles: ["DD_PAYMENT_FACILITATOR_ADMIN"],
    type: "fo",
    id: "payment-facilitator-users",
    children: [],
  },
  {
    text: "Manage Users",
    icon: "merchant-user",
    authorities: [
      "bo_dd_view_participant_users",
      "bo_dd_view_bank_users",
      "bo_dd_view_facilitator_users",
    ],
    roles: [],
    id: "manage-users",
    children: [
      {
        text: "Participant Users",
        route: "/back-office/participant-users",
        authority: "bo_dd_view_participant_users",
        type: "bo",
        id: "participant-users",
      },
      {
        text: "Back Office Users",
        route: "/back-office/user-management",
        authority: "bo_dd_view_bank_users",
        type: "bo",
        id: "backoffice-users",
        roles: [],
      },
      {
        text: "Payment Facilitator Users",
        route: "/back-office/payment-facilitator-users",
        authority: "bo_dd_view_facilitator_users",
        type: "bo",
        id: "payment-facilitator-users",
        roles: [],
      },
    ],
  },
  {
    text: "Manage Transactions",
    icon: "transaction",
    authorities: [
      "bo_dd_get_all_transactions",
      "fo_dd_get_all_transactions",
      "bo_dd_view_dispute_refunds_on_awaiting_requery",
      "bo_dd_view_settlements_on_awaiting_requery",
    ],
    roles: ["DD_BANK_ADMIN"],
    id: "manage-transactions",
    children: [
      {
        text: "Transactions",
        route: "/back-office/transactions",
        authority: "bo_dd_get_all_transactions",
        type: "bo",
        id: "transactions",
        roles: [],
      },
      {
        text: "Transactions",
        route: "/front-office/transactions",
        authority: "fo_dd_get_all_transactions",
        type: "fo",
        id: "transactions",
        roles: [],
      },
    ],
  },
  {
    text: "Bulk Settlements",
    route: "/back-office/bulk-settlements",
    icon: "terminals",
    authority: "bo_dd_get_all_bulk_settlement",
    roles: [],
    type: "bo",
    id: "settlements",
    children: [],
  },
  {
    text: "Bulk Settlements",
    route: "/front-office/bulk-settlements",
    icon: "terminals",
    authority: "fo_dd_get_all_bulk_settlement",
    roles: ["DD_PAYMENT_FACILITATOR_ADMIN"],
    type: "fo",
    id: "bulk-settlements",
    children: [],
  },
  {
    text: "Debit Mandates",
    route: "/back-office/mandates",
    icon: "mandates",
    authority: "bo_view_debit_mandates",
    roles: [""],
    type: "bo",
    id: "bo-mandates",
    children: [],
  },
  {
    text: "Debit Mandate Configurations",
    route: "/back-office/debit-mandate-configurations",
    icon: "mandate-config",
    authority: "bo_setup_global_debit_mandate_config",
    roles: [""],
    type: "bo",
    id: "mandate-configurations",
    children: [],
  },
  {
    text: "Debit Mandate Configurations",
    route: "/front-office/debit-mandate-configurations",
    icon: "mandate-config",
    authority: "fo_view_debit_mandates",
    roles: [""],
    type: "fo",
    id: "mandate-configurations",
    children: [],
  },
  {
    text: "Merchant Categories",
    route: "/back-office/merchant-categories",
    icon: "merchant-categories",
    authority: "bo_dd_manage_merchant_category",
    roles: [],
    type: "bo",
    id: "merchant-categories",
    children: [],
  },
  {
    text: "Debit Mandates",
    route: "/front-office/mandates",
    icon: "mandates",
    authority: "fo_view_debit_mandates",
    roles: [],
    type: "fo",
    id: "fo-mandates",
    children: [],
  },
  {
    text: "Manage Disputes",
    icon: "dispute",
    authorities: ["bo_dd_get_dispute", "fo_dd_get_dispute"],
    roles: [],
    id: "disputes",
    children: [
      {
        text: "Against Bank",
        route: "/back-office/disputes/bank",
        icon: "dispute",
        authority: "bo_dd_get_dispute",
        type: "bo",
        id: "bank-disputes",
      },
      {
        text: "Against Payment Facilitator",
        route: "/back-office/disputes/payment-facilitator",
        icon: "dispute",
        authority: "bo_dd_get_dispute",
        type: "bo",
        id: "facilitator-disputes",
      },
      {
        text: "Against Bank",
        route: "/front-office/disputes/bank",
        icon: "dispute",
        authority: "fo_dd_get_dispute",
        type: "fo",
        id: "bank-disputes",
      },
      {
        text: "Against Payment Facilitator",
        route: "/front-office/disputes/payment-facilitator",
        icon: "dispute",
        authority: "fo_dd_get_dispute",
        type: "fo",
        id: "facilitator-disputes",
      },
    ],
  },
  {
    text: "Workflow Authorizations",
    icon: "workflow",
    authorities: ["bo_dd_view_all_workflow_requests", "all"],
    id: "workflow-authorizations",
    children: [
      {
        text: "My Requests",
        route: "/back-office/workflow-requests/self",
        authority: "all",
        type: "bo",
        id: "my-requests",
      },
      {
        text: "All Requests",
        route: "/back-office/workflow-requests/all",
        authority: "bo_dd_view_all_workflow_requests",
        type: "bo",
        id: "all-requests",
      },
    ],
  },
  {
    text: "Settings",
    icon: "settings",
    authority: "all",
    roles: [],
    id: "settings",
    children: [
      {
        text: "Integration Details",
        route: "/front-office/integration-details",
        authority: "fo_dd_get_facilitator_secret",
        type: "fo",
        id: "integration-details",
      },
      {
        text: "Change Password",
        route: "/account/change-password",
        authority: "all",
        type: "all",
        id: "change-password",
        roles: [],
      },
      {
        text: "Public Holidays",
        route: "/back-office/public-holidays",
        authority: "bo_dd_manage_public_holidays",
        type: "bo",
        id: "public-holidays",
        roles: [],
      },
      {
        text: "Configurations",
        route: "/back-office/configurations",
        authority: "bo_dd_view_configurations",
        type: "bo",
        id: "configurations",
        roles: [],
      },
      {
        text: "Transit Account Setup",
        route: "/back-office/transit-accounts",
        authority: "bo_dd_view_all_settlement_transit_accounts",
        type: "bo",
        id: "transit-account-setup",
        roles: [],
      },
      {
        text: "Authentication Limits",
        route: "/back-office/settings/verification-limits",
        authority: "bo_dd_view_verification_limits",
        type: "bo",
        id: "verification-limits",
      },
    ],
  },
];
